import React from 'react'
import {QueryClientProvider} from '@tanstack/react-query'
import { createRoot } from 'react-dom/client';
import App from './components/App';
import {queryClient} from "./components/ProductService";



const root = createRoot(
    document.getElementById('root')
)

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
)
